import { RefObject, useCallback, useEffect, useState } from 'react';

export type GetTopLeft = (
  element: HTMLElement
) => {
  top: number;
  left?: number;
  right?: number;
};

export const usePositionableDialog = (
  getTopLeft: GetTopLeft,
  anchorRef: RefObject<HTMLElement>
) => {
  const [topLeft, setTopLeft] = useState(getTopLeft(anchorRef.current));

  const handleWindowResize = useCallback(() => {
    setTopLeft(getTopLeft(anchorRef.current));
  }, [anchorRef, setTopLeft, getTopLeft]);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [handleWindowResize]);

  useEffect(() => {
    setTopLeft(getTopLeft(anchorRef.current));
  }, [setTopLeft, getTopLeft, anchorRef]);

  const calculatedStyle = {
    ...topLeft,
  };

  return calculatedStyle;
};
